export const MODELS = [
  {
    name: "auto",
    label: "Auto",
    textScore: 0,
    qualityScore: 0,
    speedScore: 0,
    fandomScore: 0,
    nsfw: true,
    imageText: true,
    imageEdits: true,
    includedImageTotals: [1, 2, 4],
    includedAspectRatios: ["1:1", "2:3", "9:16", "16:9", "3:4", "4:3", "3:2"],
    premiumOnly: false,
  },
  {
    name: "hd-turbo",
    label: "Idyllic Base",
    textScore: 2,
    qualityScore: 1,
    speedScore: 2,
    fandomScore: 5,
    nsfw: true,
    imageText: false,
    imageEdits: false,
    includedImageTotals: [1, 2, 4],
    includedAspectRatios: [
      "1:1",
      "2:3",
      "9:16",
      "16:9",
      "3:4",
      "4:3",
      "3:2",
      "21:9",
      "7:4",
      "5:4",
    ],
    premiumOnly: false,
  },
  {
    name: "hd",
    label: "Idyllic HD",
    textScore: 3,
    qualityScore: 2,
    speedScore: 1,
    fandomScore: 5,
    nsfw: true,
    imageText: true,
    imageEdits: false,
    includedImageTotals: [1],
    includedAspectRatios: [
      "1:1",
      "2:3",
      "9:16",
      "16:9",
      "3:4",
      "4:3",
      "3:2",
      "21:9",
      "7:4",
      "5:4",
    ],
    premiumOnly: true,
  },
  {
    name: "hd+",
    label: "Idyllic HDR+",
    textScore: 3,
    qualityScore: 3,
    speedScore: 1,
    fandomScore: 4,
    nsfw: false,
    imageText: true,
    imageEdits: false,
    includedImageTotals: [1],
    includedAspectRatios: [
      "1:1",
      "2:3",
      "9:16",
      "16:9",
      "3:4",
      "4:3",
      "3:2",
      "21:9",
      "7:4",
      "5:4",
    ],
    premiumOnly: true,
  },
  {
    name: "imagen-4",
    label: "Imagen 4",
    textScore: 5,
    qualityScore: 4,
    speedScore: 5,
    fandomScore: 4,
    nsfw: false,
    imageText: true,
    imageEdits: false,
    includedImageTotals: [1, 2, 4],
    includedAspectRatios: ["1:1", "9:16", "16:9", "3:4", "4:3"],
    premiumOnly: false,
  },
  {
    name: "nsfw-fast",
    label: "NSFW Fast",
    textScore: 2,
    qualityScore: 1,
    speedScore: 2,
    fandomScore: 5,
    nsfw: true,
    imageText: false,
    imageEdits: false,
    includedImageTotals: [1, 2, 4],
    includedAspectRatios: [
      "1:1",
      "2:3",
      "9:16",
      "16:9",
      "3:4",
      "4:3",
      "3:2",
      "21:9",
      "7:4",
      "5:4",
    ],
    premiumOnly: false,
  },
  {
    name: "nsfw",
    label: "NSFW",
    textScore: 3,
    qualityScore: 2,
    speedScore: 1,
    fandomScore: 5,
    nsfw: true,
    imageText: true,
    imageEdits: false,
    includedImageTotals: [1],
    includedAspectRatios: [
      "1:1",
      "2:3",
      "9:16",
      "16:9",
      "3:4",
      "4:3",
      "3:2",
      "21:9",
      "7:4",
      "5:4",
    ],
    premiumOnly: false,
  },
  {
    name: "gpt",
    label: "GPT Image",
    textScore: 5,
    qualityScore: 4,
    speedScore: 1,
    fandomScore: 1,
    nsfw: false,
    imageText: true,
    imageEdits: true,
    includedImageTotals: [1],
    includedAspectRatios: ["1:1", "2:3", "3:2"],
    premiumOnly: true,
  },
  {
    name: "flux-pro",
    label: "Flux Pro",
    textScore: 3,
    qualityScore: 3,
    speedScore: 1,
    fandomScore: 4,
    nsfw: false,
    imageText: true,
    imageEdits: false,
    includedImageTotals: [1],
    includedAspectRatios: ["1:1", "3:4", "4:3", "9:16", "16:9"],
    premiumOnly: true,
  },
  {
    name: "imagen-4-ultra",
    label: "Imagen 4 Ultra",
    textScore: 5,
    qualityScore: 5,
    speedScore: 4,
    fandomScore: 4,
    nsfw: false,
    imageText: true,
    imageEdits: false,
    includedImageTotals: [1],
    includedAspectRatios: ["1:1", "9:16", "16:9", "3:4", "4:3"],
    premiumOnly: true,
  },
  {
    name: "grok-2",
    label: "Grok 2",
    textScore: 4,
    qualityScore: 1,
    speedScore: 4,
    fandomScore: 4,
    nsfw: false,
    imageText: true,
    imageEdits: false,
    includedImageTotals: [1, 2],
    includedAspectRatios: ["3:4"],
    premiumOnly: true,
  },
];
